function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterFilterInlet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2752",
    d: "M16.034 0H16a15.983 15.983 0 1 0 .034 0M16 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14",
    style: {
      fill: "#ff7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2753",
    d: "M18.7 14.326c0-1.457-2.7-5.2-2.7-5.2s-2.7 3.747-2.7 5.2a2.7 2.7 0 0 0 5.4 0m-1.5-.875a.728.728 0 0 1 .686.667.686.686 0 1 1-.686-.667m7.38 9.458v1H7.42v-1h7.413v-2.443a7.356 7.356 0 0 1-3.4-1.4l.6-.8a6.689 6.689 0 1 0-2.346-3.507l2.184-1.2-1.2 4.123-4.124-1.2 2.238-1.23a7.44 7.44 0 1 1 8.047 5.232v2.423zM7.42 24.893h17.159v1H7.42z",
    transform: "translate(0 -1)",
    style: {
      fill: "#f5f5f5"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterFilterInlet);
export default __webpack_public_path__ + "static/media/water-filter-inlet.d55d4fea4fdbf2f283f0d0aa1d184d3e.svg";
export { ForwardRef as ReactComponent };